module.exports = __webpack_public_path__ + "static/tiamats-emergence-from-avernus-b83a08ff3cae45a092c495053c0711de.png";